namespace Gamification.Gamification {
    export interface UtentiProdottiConProprietaForm {
        IdUtenteProdotto: Serenity.IntegerEditor;
        IdUtente: Serenity.IntegerEditor;
        IdProdotto: Serenity.IntegerEditor;
        IdentifierUtente: Serenity.StringEditor;
        Cognome: Serenity.StringEditor;
        Nome: Serenity.StringEditor;
        Email: Serenity.StringEditor;
        Prodotto: Serenity.StringEditor;
        Locked: Serenity.BooleanEditor;
        IdTipologiaProdotti: Serenity.IntegerEditor;
        IdentifierProdotto: Serenity.StringEditor;
        UserId: Serenity.IntegerEditor;
        Azienda: Serenity.StringEditor;
    }

    export class UtentiProdottiConProprietaForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdottiConProprieta';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiConProprietaForm.init)  {
                UtentiProdottiConProprietaForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(UtentiProdottiConProprietaForm, [
                    'IdUtenteProdotto', w0,
                    'IdUtente', w0,
                    'IdProdotto', w0,
                    'IdentifierUtente', w1,
                    'Cognome', w1,
                    'Nome', w1,
                    'Email', w1,
                    'Prodotto', w1,
                    'Locked', w2,
                    'IdTipologiaProdotti', w0,
                    'IdentifierProdotto', w1,
                    'UserId', w0,
                    'Azienda', w1
                ]);
            }
        }
    }
}
